const SidebarData = [
  {
    label: "Menu",
    isMainMenu: true,
  },
  // {
  //   label: "Dashboard",
  //   icon: "mdi mdi-home-variant-outline",
  //   url: "/dashboard",
  //   issubMenubadge: true,
  //   bgcolor: "bg-primary",
  //   badgeValue: "3",
  // },
  {
    label: "Terms & Conditions",
    icon: "mdi mdi-file-document",
    isHasArrow: true,
    url: "/TnC",
  },
  {
    label: "Privacy Policy",
    icon: "mdi mdi-file-document",
    isHasArrow: true,
    url: "/privacyPolicy",
  },
  {
    label: "Cookie Policy",
    icon: "mdi mdi-file-document",
    isHasArrow: true,
    url: "/cookiePolicy",
  },
  {
    label: "temp Table",
    icon: "mdi mdi-table",
    isHasArrow: true,
    url: "/tempTable",
  },
  {
    label: "Looking For",
    icon: "mdi mdi-eye",
    isHasArrow: true,
    url: "/lookingFor",
  },
  {
    label: "School",
    icon: "mdi mdi-school-outline",
    isHasArrow: true,
    url: "/school",
  },
  {
    label: "Company",
    icon: "mdi mdi-domain",
    isHasArrow: true,
    url: "/company",
  },
  {
    label: "Job",
    icon: "mdi mdi-briefcase-outline",
    isHasArrow: true,
    url: "/job",
  },
  {
    label: "Degree",
    icon: "mdi mdi-file-outline",
    isHasArrow: true,
    url: "/degree",
  },
  {
    label: "FoS",
    icon: "mdi mdi-filter-outline",
    isHasArrow: true,
    url: "/fos",
  },
  {
    label: "Sports",
    icon: "mdi mdi-run-fast",
    isHasArrow: true,
    url: "/sports",
  },
  {
    label: "Interest",
    icon: "mdi mdi-heart-outline",
    subItem: [
      { sublabel: "Interest", link: "/interest" },
      { sublabel: "Group Interest", link: "/group-interest" },
      {
        sublabel: "Interest Group Association",
        link: "/interest-group-association",
      },
    ],
  },
  {
    label: "Skills",
    icon: "mdi mdi-lightbulb-on-outline",
    subItem: [
      { sublabel: "Skills", link: "/skills" },
      { sublabel: "Group Skills", link: "/group-skills" },
      {
        sublabel: "Skills Group Association",
        link: "/skills-group-association",
      },
    ],
  },
  {
    label: "Analytics",
    icon: "mdi mdi-google-analytics",
    subItem: [
      { sublabel: "Looking For Analytics", link: "/lookingForAnalytics" },
      { sublabel: "Gender Analytics", link: "/GenderAnalytics" },
      { sublabel: "Interests Analytics", link: "/InterestGroupAnalytics" },
    ],
  },
];
export default SidebarData;